import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

export const useStatement = ({ id, skip = false }: any = {}) => {
  const { data, error, loading } = useQuery<
    GetStatementQuery,
    GetStatementQueryVariables
  >(GET_STATEMENT_QUERY, {
    skip,
    variables: { id: parseInt(id), source: null },
  });

  return { data: data?.statement, error, loading };
};

export const GET_STATEMENT_QUERY = gql`
  query GetStatement($id: Int!, $source: String) {
    statement(id: $id, source: $source) {
      id
      collectAutomatically
      invoiceUrl
      status
      issuedAt
      paymentScheduledAt
      delayable
      maxDelayDate
      refundedAmountCents
      total
      totalBeforeSolarSavings
      lineItemSummary {
        headlineSolarSavingsRate
      }
      lineItems {
        id
        entryType
        key
        name
        metadata
        amountCents
        void
      }
      paymentTransactions {
        id
        disputeId
      }
      singleUtilityStatement {
        id
        kwh
        utilityCharge
        vnmBillCredits
        serviceStartDate
        serviceEndDate
      }
      utilityStatements {
        id
        serviceEndDate
        serviceStartDate
        utilityAccount {
          id
          accountNumber
          displayServiceAddress
        }
      }
      hostReportItems {
        id
        dateReadingFrom
        dateReadingTo
        productionStartDate
        productionEndDate
        utilityAccount {
          id
          accountNumber
          displayServiceAddress
        }
      }
    }
  }
`;

export const getStatementMock: GetStatementQuery = {
  statement: {
    id: 2,
    collectAutomatically: true,
    delayable: false,
    issuedAt: '2020-02-14',
    invoiceUrl: 'https://stripe.com/invoice/2',
    lineItemSummary: {
      headlineSolarSavingsRate: 5,
    },
    lineItems: [
      {
        amountCents: 500,
        entryType: 'debit',
        id: '10',
        key: 'vnm_solar_charge',
        metadata: {
          vnmCreditDeductibleCents: 400,
        },
        name: 'Arcadia membership',
        void: false,
      },
    ],
    maxDelayDate: '2020-02-17',
    paymentScheduledAt: '2020-02-15',
    paymentTransactions: [
      {
        id: 100,
        disputeId: null,
      },
    ],
    status: 'issued',
    total: 500,
    totalBeforeSolarSavings: 400,
    refundedAmountCents: 100,
    singleUtilityStatement: {
      id: 1,
      kwh: 234,
      serviceEndDate: '2020-02-01',
      serviceStartDate: '2020-01-01',
      utilityCharge: 800,
      vnmBillCredits: 400,
    },
    utilityStatements: [
      {
        id: 1,
        serviceEndDate: '2020-02-01',
        serviceStartDate: '2020-01-01',
        utilityAccount: {
          id: 2,
          accountNumber: '123',
          displayServiceAddress: '123 Test Rd, Someplace, MD 20877',
        },
      },
    ],
    hostReportItems: [
      {
        id: 1,
        dateReadingFrom: null,
        dateReadingTo: null,
        productionEndDate: '2020-02-01',
        productionStartDate: '2020-01-01',
        utilityAccount: {
          id: 2,
          accountNumber: '123',
          displayServiceAddress: '123 Test Rd, Someplace, MD 20877',
        },
      },
    ],
  },
};

export const useStatementMock = {
  data: getStatementMock.statement,
  error: undefined,
  loading: false,
};
